import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ToastMessage } from './toast-message.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messagesQueue: ToastMessage[] = [];

  constructor(private snackBar: MatSnackBar) {}

  /**
   * Starts the process to display a message.
   * Stacks messages when the queue is over 1.
   * @param text the message's text
   * @param actionText label for action button
   * @param callbackAction gets called when action is triggered
   */
  openSnackBar(text: string, actionText: string, callbackAction?: (value: any) => void): void {
    this.messagesQueue.push({ text, actionText, callbackAction });
    const [currentMessage]: ToastMessage[] = this.messagesQueue;

    if (this.messagesQueue.length === 1) {
      this.showCurrentMessage(currentMessage);
    }
  }

  public showToastMessage(text: string, actionText: string): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(text, actionText, {
      panelClass: ['mat-elevation-z3'],
      duration: 3000
    });
  }

  /**
   * Shows the current messages and checks for next in the queue when dismissed.
   * @param message current message to display.
   */
  private showCurrentMessage(message: ToastMessage): void {
    const snackRef: MatSnackBarRef<SimpleSnackBar> = this.showToastMessage(message.text, message.actionText);

    if (typeof message.callbackAction === 'function') {
      snackRef.onAction().subscribe(message.callbackAction);
    }

    // removes the first message of the queue and calls itselft if there more messages left.
    snackRef.afterDismissed().subscribe(() => {
      this.messagesQueue.shift();

      const [currentMessage]: ToastMessage[] = this.messagesQueue;

      if (this.messagesQueue.length > 0) {
        this.showCurrentMessage(currentMessage);
      }
    });
  }
}
